import { Box, CircularProgress, Grid, Typography } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import cx from 'classnames';
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import useStyles from './styles';

interface IProps {
  onFileLoaded: (file: File, blob: Blob, encodedImage: string, extName: string) => void;
  src?: string;
  readonly?: boolean;
  isPending?: boolean;
  placeholderRenderer?: () => JSX.Element;
  className?: string;
  imageWrapClassName?: string;
  descriptionClassName?: string;
}

const regex = /(http[s]?:\/\/|data:image)/;

export const ImageUpload = (props: IProps): JSX.Element => {
  const classes = useStyles();

  const { src, placeholderRenderer } = props;

  const getExt = (fileType: string): string => {
    switch (fileType) {
      case 'image/jpeg':
        return 'jpg';
      case 'image/gif':
        return 'gif';
      case 'image/png':
        return 'png';
      default:
        return '';
    }
  };

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      const file = acceptedFiles[0];
      const reader = new FileReader();
      const blob = new Blob([file], { type: file.type });

      reader.onload = () => {
        const { result } = reader;

        props.onFileLoaded(file, blob, result as string, getExt(file.type));
      };

      reader.readAsDataURL(file);
    },
    [props],
  );

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <Paper className={cx(classes.fileUploadBox, props.className)} {...getRootProps()}>
      {props.isPending && (
        <Box
          className={classes.backdrop}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
          }}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress color="inherit" />
        </Box>
      )}
      <Grid container direction="row" justify="flex-start" wrap="nowrap" alignItems="center">
        <Grid item className={cx(classes.previewImageWrap, props.imageWrapClassName)}>
          {src && <img src={regex.test(src) ? src : `${process.env.CDN_URL}/${src}`} alt="default image" className={classes.previewImage} />}
          {!src && placeholderRenderer && (
            <Box display="flex" width="100%" justifyContent="center" alignItems="center">
              {placeholderRenderer()}
            </Box>
          )}
          <input {...getInputProps()} disabled={props.readonly} />
        </Grid>
        {!props.readonly && (
          <Grid item className={props.descriptionClassName}>
            <CloudUploadOutlinedIcon className={classes.fileUploadIcon} />
            <Typography variant="body2" className={classes.alignCenter}>
              {'Drag & drop or click here to upload photo '}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};
